import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeQuickTestComponent } from './quick-test.component';
import { MeQuickTestResultComponent } from './result/quick-test-result.component';

const routes: Routes = [
    {   
        path: '', 
        component: MeQuickTestComponent,
    },
    {   
        path: 'result/:slug', 
        component: MeQuickTestResultComponent,
    },
    {   
        path: 'result/:slug/:numberCategories/:isHarm', 
        component: MeQuickTestResultComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class MeQuickTestRoutesModule { }
